import { useState } from 'react';
import { Button } from '@iwoca/orion';
import { AddNewUserModal } from './AddNewUserModal/AddNewUserModal';

export const AddNewUserButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary-alt"
        size="small"
        onClick={() => setIsModalOpen(true)}
      >
        + Add new user
      </Button>
      {isModalOpen && (
        <AddNewUserModal isOpen onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};
